import React, { Component } from 'react';
import { connect } from 'react-redux';
import validateRegistration from '../util/validateRegistration';
import PropTypes from 'prop-types';
import {
  clearRegistration,
  registerUser
} from '../actions';
import {
  getRegistrationStatus,
  getRegistrationError
} from '../reducer';
import './register.scss';
import GBIButton from '../../util/buttons/components/GBIButton';
import TickIcon from '../../util/icons/components/TickIcon';
import analytics from '../../util/analytics';

const mapStateToProps = state => ({
  status: getRegistrationStatus(state),
  apiError: getRegistrationError(state)
});

const mapDispatchToProps = dispatch => ({
  register: registration => {
    dispatch(registerUser(registration));
  },
  clear: () => dispatch(clearRegistration())
});

class Register extends Component {
  constructor (props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      password: '',
      passwordConf: '',
      org: '',
      errors: {},
      nameUsed: false,
      emailUsed: false,
      passwordUsed: false,
      passwordConfUsed: false,
      orgUsed: false
    };
    this.nameRef = React.createRef();
    this.emailRef = React.createRef();
    this.passwordRef = React.createRef();
    this.passwordConfRef = React.createRef();
    this.orgRef = React.createRef();
  }
  componentWillUnmount () {
    this.props.clear();
  }
  validate () {
    const { email, name, password, passwordConf, org } = this.state;
    const registration = validateRegistration({
      email, name, password, passwordConf, org
    });
    if (registration.errors) {
      this.setState({ errors: registration.errors });
    } else {
      this.setState({ errors: {} });
    }
  }
  handleNameChange () {
    const name = this.nameRef.current.value;
    this.setState({ name, nameUsed: true }, this.validate);
  }
  handleEmailChange () {
    const email = this.emailRef.current.value.toLowerCase();
    this.setState({ email, emailUsed: true }, this.validate);
  }
  handlePasswordChange () {
    const password = this.passwordRef.current.value;
    this.setState({ password, passwordUsed: true }, this.validate);
  }
  handlePasswordConfChange () {
    const passwordConf = this.passwordConfRef.current.value;
    this.setState({ passwordConf, passwordConfUsed: true }, this.validate);
  }
  handleOrgChange () {
    const org = this.orgRef.current.value;
    this.setState({ org, orgUsed: true }, this.validate);
  }
  register () {
    const { email, name, password, passwordConf, org } = this.state;
    const registration = validateRegistration({
      email, name, password, passwordConf, org
    });
    if (registration.valid && this.props.status !== 'REGISTERING') {
      this.props.register(registration);
      analytics(
        'send',
        'event',
        'Signup',
        'userRegistered',
        email
      );
    }
  }
  renderName () {
    let wrapperClass = 'input-wrapper';
    let error = null;
    let tickClass = 'tick-radio';
    if (this.state.errors && this.state.errors.name && this.state.nameUsed) {
      wrapperClass += ' error';
      error = (
        <div className="error-feedback" data-cy="name-error">
          { this.state.errors.name }
        </div>
      );
    } else if (this.state.name) {
      tickClass += ' ticked';
    }
    return (
      <div className={ wrapperClass }>
        <div className={ tickClass } ><TickIcon /></div>
        <input ref={ this.nameRef }
          placeholder="name"
          data-cy="name-field"
          onChange={ this.handleNameChange.bind(this) } />
        { error }
      </div>
    );
  }
  renderEmail () {
    let wrapperClass = 'input-wrapper';
    let error = null;
    let tickClass = 'tick-radio';
    if (this.state.errors && this.state.errors.email && this.state.emailUsed) {
      wrapperClass += ' error';
      error = (
        <div className="error-feedback" data-cy="email-error">
          { this.state.errors.email }
        </div>
      );
    } else if (this.state.email) {
      tickClass += ' ticked';
    }
    return (
      <div className={ wrapperClass }>
        <div className={ tickClass } ><TickIcon /></div>
        <input ref={ this.emailRef }
          placeholder="email"
          data-cy="email-field"
          onChange={ this.handleEmailChange.bind(this) } />
        { error }
      </div>
    );
  }
  renderPassword () {
    let wrapperClass = 'input-wrapper';
    let error = null;
    let tickClass = 'tick-radio';
    if (this.state.errors && this.state.errors.password &&
    this.state.passwordUsed) {
      wrapperClass += ' error';
      error = (
        <div className="error-feedback" data-cy="password-error">
          { this.state.errors.password }
        </div>
      );
    } else if (this.state.password) {
      tickClass += ' ticked';
    }
    return (
      <div className={ wrapperClass }>
        <div className={ tickClass } ><TickIcon /></div>
        <input ref={ this.passwordRef }
          type="password"
          placeholder="password"
          data-cy="password-field"
          autoComplete="new-password"
          onFocus={ () => this.setState({ passwordFocus: true }) }
          onBlur={ () => this.setState({ passwordFocus: false }) }
          onChange={ this.handlePasswordChange.bind(this) } />
        { error }
      </div>
    );
  }
  renderPasswordConf () {
    // if (this.state.password === '' && this.state.passwordFocus === true) {
    //   return null;
    // }
    let wrapperClass = 'input-wrapper';
    let error = null;
    let tickClass = 'tick-radio';
    if (this.state.errors && this.state.errors.passwordConf &&
    this.state.passwordConfUsed) {
      wrapperClass += ' error';
      error = (
        <div className="error-feedback" data-cy="password-conf-error">
          { this.state.errors.passwordConf }
        </div>
      );
    } else if (this.state.passwordConf) {
      tickClass += ' ticked';
    }
    return (
      <div className={ wrapperClass }>
        <div className={ tickClass } ><TickIcon /></div>
        <input ref={ this.passwordConfRef }
          type="password"
          placeholder="confirm password"
          data-cy="conf-password-field"
          autoComplete="new-password"
          onChange={ this.handlePasswordConfChange.bind(this) } />
        { error }
      </div>
    );
  }
  renderOrg () {
    let wrapperClass = 'input-wrapper';
    let error = null;
    let tickClass = 'tick-radio';
    if (this.state.errors && this.state.errors.org && this.state.orgUsed) {
      wrapperClass += ' error';
      error = (
        <div className="error-feedback" data-cy="org-error">
          { this.state.errors.org }
        </div>
      );
    } else if (this.state.org) {
      tickClass += ' ticked';
    }
    return (
      <div className={ wrapperClass }>
        <div className={ tickClass } ><TickIcon /></div>
        <input ref={ this.orgRef }
          placeholder="organisation"
          data-cy="org-field"
          onChange={ this.handleOrgChange.bind(this) } />
        { error }
      </div>
    );
  }
  renderButton () {
    let registerButton = null;
    if (!this.state.errors || Object.keys(this.state.errors).length < 1) {
      const className = this.props.status === 'REGISTERING' ? 'disabled' : '';
      registerButton = (
        <GBIButton label="Register"
          testId="register-button"
          className={ className }
          onClick={ this.register.bind(this) }/>
      );
    }
    return (
      <div className="button-row">
        { registerButton }
      </div>
    );
  }
  render () {
    const message = window.location.hostname.includes('beefbook') ?
      'BeefBook shares GoodBeef Index admin resources. Create an account now' :
      'Start using the GoodBeef Index straight away';
    return (
      <div id="user-registration">
        <p className="instruction-text" data-cy="register-instructions">
          { message }
        </p>
        <div className="inputs">
          { this.renderName() }
          { this.renderEmail() }
          { this.renderOrg() }
          { this.renderPassword() }
          { this.renderPasswordConf() }
        </div>
        { this.renderButton() }
      </div>
    );
  }
}

Register.propTypes = {
  register: PropTypes.func.isRequired,
  status: PropTypes.string,
  apiError: PropTypes.string,
  clear: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
